<template>
  <div class="sidebar-wrapper" :class="{ collapsed: isCollapsed }">
    <!-- 折叠/展开按钮 -->
    <div class="toggle-btn" @click="toggleSidebar">
      <span class="toggle-icon">{{ isCollapsed ? '▶' : '◀' }}</span>
    </div>

    <!-- 侧边栏内容 -->
    <div class="sidebar" :class="{ collapsed: isCollapsed }">
      <!-- 用户信息区 -->
      <div class="user-section" v-if="!isCollapsed">
        <div class="user-avatar">
          <span>管</span>
        </div>
        <div class="user-info">
          <div class="user-name">系统管理员</div>
          <div class="user-role">超级管理员</div>
        </div>
      </div>

      <!-- 导航菜单 -->
      <nav class="nav-menu">
        <div
          v-for="item in menuItems"
          :key="item.key"
          class="nav-item"
          :class="{ active: activeModule === item.key, collapsed: isCollapsed }"
          @click="selectModule(item.key)"
        >
          <div class="nav-icon">
            <span v-html="item.icon"></span>
          </div>
          <span class="nav-text" v-if="!isCollapsed">{{ item.label }}</span>
          <!-- 激活指示条 -->
          <div class="active-indicator" v-if="activeModule === item.key && !isCollapsed"></div>
        </div>
      </nav>

      <!-- 底部信息 -->
      <div class="sidebar-footer" v-if="!isCollapsed">
        <div class="footer-line"></div>
        <div class="footer-text">CRM System v2.0</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SideBar',
  props: {
    activeModule: {
      type: String,
      default: 'CrmDashboard'
    }
  },
  data() {
    return {
      isCollapsed: false,
      menuItems: [
        {
          key: 'CrmDashboard',
          label: '首页大屏',
          icon: '◈'
        },
        {
          key: 'CrmSales',
          label: '销售管理',
          icon: '◉'
        },
        {
          key: 'CrmMarketing',
          label: '营销自动化',
          icon: '▣'
        },
        {
          key: 'CrmService',
          label: '客户服务',
          icon: '▤'
        },
        {
          key: 'CrmAnalytics',
          label: '数据分析',
          icon: '◊'
        }
      ]
    }
  },
  mounted() {
    this.checkScreenWidth()
    window.addEventListener('resize', this.checkScreenWidth)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenWidth)
  },
  methods: {
    toggleSidebar() {
      this.isCollapsed = !this.isCollapsed
    },
    selectModule(module) {
      this.$emit('changeModule', module)
    },
    checkScreenWidth() {
      // 屏幕宽度小于 1024px 时自动收起
      if (window.innerWidth < 1024) {
        this.isCollapsed = true
      } else {
        this.isCollapsed = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar-wrapper {
  position: relative;
  flex-shrink: 0;
  transition: all 0.3s ease;

  &.collapsed {
    width: 64px;
  }
}

.toggle-btn {
  position: absolute;
  top: 20px;
  right: -12px;
  width: 24px;
  height: 24px;
  background: #1B5E20;
  border: 2px solid #4CAF50;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: all 0.3s ease;
  box-shadow: 0 0 10px rgba(76, 175, 80, 0.3);

  &:hover {
    background: #2E7D32;
    transform: scale(1.1);
    box-shadow: 0 0 15px rgba(76, 175, 80, 0.5);
  }

  .toggle-icon {
    font-size: 10px;
    color: #81C784;
    line-height: 1;
  }
}

.sidebar {
  width: 220px;
  height: 100%;
  background: linear-gradient(180deg, #102A15 0%, #0d2311 100%);
  border-right: 1px solid rgba(76, 175, 80, 0.1);
  display: flex;
  flex-direction: column;
  transition: width 0.3s ease;
  overflow: hidden;

  &.collapsed {
    width: 64px;

    .toggle-btn {
      right: -12px;
    }
  }
}

// ===== 用户信息区 =====
.user-section {
  padding: 24px 16px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid rgba(76, 175, 80, 0.08);

  .user-avatar {
    width: 42px;
    height: 42px;
    background: linear-gradient(135deg, #4CAF50, #2E7D32);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    box-shadow: 0 0 15px rgba(76, 175, 80, 0.25);

    span {
      font-size: 16px;
      font-weight: 600;
      color: #fff;
    }
  }

  .user-info {
    overflow: hidden;

    .user-name {
      font-size: 14px;
      font-weight: 600;
      color: #e8f5e9;
      white-space: nowrap;
    }

    .user-role {
      font-size: 11px;
      color: #66BB6A;
      margin-top: 2px;
      opacity: 0.7;
    }
  }
}

// ===== 导航菜单 =====
.nav-menu {
  flex: 1;
  padding: 16px 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.nav-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.25s ease;
  overflow: hidden;

  &:hover {
    background: rgba(76, 175, 80, 0.08);

    .nav-icon {
      color: #81C784;
      transform: scale(1.1);
    }

    .nav-text {
      color: #a5d6a7;
    }
  }

  &.active {
    background: rgba(76, 175, 80, 0.12);
    
    .nav-icon {
      color: #4CAF50;
    }

    .nav-text {
      color: #e8f5e9;
      font-weight: 600;
    }
  }

  &.collapsed {
    justify-content: center;
    padding: 12px 0;

    .nav-icon {
      margin: 0;
    }
  }

  .nav-icon {
    width: 22px;
    height: 22px;
    color: #66BB6A;
    flex-shrink: 0;
    transition: all 0.25s ease;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 100%;
      height: 100%;
    }
  }

  .nav-text {
    font-size: 14px;
    color: #a5d6a7;
    white-space: nowrap;
    transition: all 0.25s ease;
  }

  .active-indicator {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 20px;
    background: linear-gradient(180deg, #4CAF50, #81C784);
    border-radius: 0 3px 3px 0;
    box-shadow: 0 0 8px rgba(76, 175, 80, 0.5);
  }
}

// ===== 底部 =====
.sidebar-footer {
  padding: 16px;
  border-top: 1px solid rgba(76, 175, 80, 0.08);

  .footer-line {
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(76, 175, 80, 0.2), transparent);
    margin-bottom: 10px;
  }

  .footer-text {
    text-align: center;
    font-size: 10px;
    color: #4CAF50;
    opacity: 0.5;
    letter-spacing: 1px;
  }
}
</style>